/**
 * @generated SignedSource<<f102bde1de596ea755db14a053c896e1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteLabelInput = {
  id: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deleteLabelMutation$variables = {
  input: DeleteLabelInput;
};
export type deleteLabelMutation$data = {
  readonly deleteLabel: {
    readonly deletedLabelId: string | null;
  } | null;
};
export type deleteLabelMutation = {
  variables: deleteLabelMutation$variables;
  response: deleteLabelMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteLabelPayload",
    "kind": "LinkedField",
    "name": "deleteLabel",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedLabelId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deleteLabelMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deleteLabelMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3da18d9d35e334ae62af8438ff094dea",
    "id": null,
    "metadata": {},
    "name": "deleteLabelMutation",
    "operationKind": "mutation",
    "text": "mutation deleteLabelMutation(\n  $input: DeleteLabelInput!\n) {\n  deleteLabel(input: $input) {\n    deletedLabelId\n  }\n}\n"
  }
};
})();

(node as any).hash = "91e3b5764b3c66584b6dde30d6a8780e";

export default node;
